export default "__VITE_ASSET__fpFUjBFg__"